import { render, staticRenderFns } from "./ScheduleRuleSetting.vue?vue&type=template&id=2b8e80d0"
import script from "./ScheduleRuleSetting.vue?vue&type=script&lang=js"
export * from "./ScheduleRuleSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports